<!-- header -->
<div class="header">
    <div style="flex: 1"></div>
</div>

<!-- business info & privacy -->
<img class="business-image" aria-hidden="true" alt="" [src]="logoImage"/>
<span class="business-name two-lines" [title]="businessName">{{businessName}}</span>

<div class="disclaimer-scrollable-container">
    <div class="business-links">
        <ng-container *ngFor="let disclaimer of disclaimers">
            <div [innerHTML]=disclaimer></div>
        </ng-container>
    </div>

    <div *ngIf="authInfo" class="user-info">
        <div class="business-name">Profile</div>
        <div class="info-list">
            <div *ngIf="authInfo.userId"><span class="idf m-r-5 item-icon idf-id-1"></span>{{authInfo.userId}}</div>
            <div *ngIf="authInfo.userName"><span class="idf idf-userprofile-ab-2"></span>{{authInfo.userName}} </div>
            <div *ngIf="authInfo.userEmail"><span class="idf idf-email-3"></span>{{authInfo.userEmail}}</div>
        </div>
    </div>
</div>

<!-- plan name & copyright -->
<ng-container *ngIf="!planName">
    <img src="assets/images/branding-edifecs-150-px.svg" alt="Brand Logo"/>
</ng-container>
<ng-container *ngIf="planName">
    <span class="plan-name-large two-lines" [title]="planName">{{planName}}</span>
</ng-container>
<span class="copyright-text four-lines" [title]="copyright">{{copyright}}</span>
